module.exports = require("@wordpress/data");